import type { BeckyFunctionLibrary, BeckyModel, BeckyRequestPayload } from '@wix/thunderbolt-becky-root'
import type { Data, RefSchemas, Structure } from '@wix/thunderbolt-becky-types'
import * as byref from '@wix/thunderbolt-byref'

export const resolveCommonAspects = (
	beckyModel: BeckyModel,
	masterPageStructure: Structure,
	masterPageData: Data,
	functionLibrary: BeckyFunctionLibrary,
	requestPayload: BeckyRequestPayload,
	schemas: RefSchemas
) =>
	functionLibrary.runAsyncAndReport(async () => {
		const resolveGhosts = requestPayload.resolveGhosts === 'true'

		const fetchRemoteRefs = functionLibrary.runAndReport(
			() =>
				byref.createRemoteRefsFetcher(
					functionLibrary.fetchUrl.bind(functionLibrary),
					beckyModel.clientSpecMap,
					beckyModel.publicTopology,
					requestPayload,
					undefined,
					undefined,
					// @ts-ignore
					beckyModel.experiments['specs.thunderbolt.fetch_widget_iteratively']
				),
			'createRemoteRefsFetcher'
		)

		const model = {
			...beckyModel,
			...(beckyModel.pageCompId === 'masterPage' && { structure: masterPageStructure, data: masterPageData }),
			masterPageStructure,
			masterPageData,
			requestPayload,
			resolveGhosts,
		}

		const widgetTemplatesStore = await functionLibrary.runAsyncAndReport(
			() => fetchRemoteRefs(model.data.document_data),
			'fetchRemoteRefs'
		)

		const res = functionLibrary.runAndReport(
			() => byref.resolveCommonAspects({ ...model, widgetTemplatesStore }, schemas),
			'resolveCommonAspects'
		)

		return { ...model, ...res }
	}, 'tb-byRef-resolving')
